import { useState } from "react";
import { Badge, Card, Col, ListGroup, Row } from "react-bootstrap";
import { BsFillBuildingsFill, BsFillDeviceSsdFill } from "react-icons/bs";
import { FaBackward, FaForward, FaFileInvoice, FaQuestion, FaFileInvoiceDollar } from "react-icons/fa";
import { MdEnergySavingsLeaf } from "react-icons/md";
import { TbCoins, TbZzz } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { useAuthState } from "../../context/AuthContext";
import { BiSupport } from "react-icons/bi";
import CommonUtils from "../../utils/common";


/**
 * ElvDetailsCard
 * 
 * Card to display extended information about single 
 * Energieliefervertrag.
 * 
 * Used in: ElvDetailPage.jsx
 * 
 * @param {props} leerstandModal setter for model (on/off)
 * @param {props} teilvorschreibungModal setter for modal (on/off)
 * @param {props} elv object Energieliefervertrag
 * @param {props} pastElv integer id of previous elv
 * @param {props} energyProduct object Energieprodukt
 * @param {props} tickets list of ticket objects
 */
const ElvDetailsCard = (props) => {

    // props passed from parent
    const elv = props.elv;
    const pastElv = props.pastElv;
    const product = props.energyProduct;

    const { user } = useAuthState();
    const navigate = useNavigate();
    // if true displays energy product information under 3 elv colums
    const [showProductDetails, setShowProductDetails] = useState(false);
    const [showTickets, setShowTickets] = useState(false);
    const UTILS = new CommonUtils();


    // download base64
    const download_base64 = (e) => {
        e.preventDefault();
        var linksource = `data:application/pdf;base64,${product.x_file_preisblatt}`;
        var fileName = product.x_file_preisblatt_name;
        const downloadLink = document.createElement('a');
        downloadLink.href = linksource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    // navigate to support passing this elv as object
    const supportHandler = () => {
        if (user.x_is_house_management)
            navigate('/hw/dashboard/support/neu/elv', {state: {object:elv}})
        else 
            navigate('/dashboard/support/neu/elv', {state: {object:elv}})
    }

    // GUI
    return (
        <>
            {elv.x_futureelv_id.length > 0 || pastElv !== false?
                <Row className="mb-3">
                    <Col xs="6" className="text-start" hidden={pastElv === false} >
                        <a 
                            href={`/${user.x_is_house_management? 'hw/':""}dashboard/energieliefervertraege/${pastElv}`} 
                            className="link-energo"
                            >
                                <FaBackward 
                                    style={{marginLeft: "10px"}}
                                    size={30}
                                /> 
                                <span style={{marginLeft: "10px"}}>Vorheriger Energieliefervertrag</span>
                            </a>
                    </Col>
                    <Col xs={pastElv === false? "12": "6"} className="text-end" hidden={elv.x_futureelv_id.length === 0} >
                        <a 
                            href={`/${user.x_is_house_management? 'hw/':""}dashboard/energieliefervertraege/${elv.x_futureelv_id[0]}`} 
                            className="link-energo"
                        >
                            <span style={{marginRight: "10px"}}>Nächster Energieliefervertrag</span>
                            <FaForward size={30} style={{marginRight: "10px"}}/>
                        </a>
                    </Col>
                </Row>
            : null
            }
            <Card className="shadow-lg" style={{borderRadius: "20px", borderBottom: "3px solid #a2c13f"}}>
                <Card.Body>
                    <Row className="my-3">
                        <Col xs="12" md="4" xl="4" className="border-right" style={{paddingLeft: "30px"}}>
                            <h5 className="text-dark mb-3"><FaFileInvoice size={30} />&nbsp; Energieliefervertrag</h5>
                            <small className="text-muted me-1">Belieferungsbeginn</small> {elv.x_belbeg !== 'False' ? new Date(elv.x_belbeg).toLocaleDateString('DE-de') : "TBA"} <br />
                            <small className="text-muted me-1">Vertragsende</small> {elv.x_datum_vertragsende !== 'False' ? new Date(elv.x_datum_vertragsende).toLocaleDateString('DE-de') : 'offenes Vertragsende'} <br />
                            {Number(elv.x_teilvorschreibung_brutto) !== 0 &&
                                <>
                                    <small className="text-muted me-1">Teilvorschreibung brutto</small> 
                                    {Number(elv.x_teilvorschreibung_brutto).toFixed(2)} €
                                    <br />
                                </>
                            }
                            {elv.x_anlagennummer_lieferant !== "" && elv.x_anlagennummer_lieferant !== "False" &&
                                <>
                                    <small className="text-muted me-1">Anlagennummer bei Energielieferant</small> 
                                    {elv.x_anlagennummer_lieferant}
                                    <br />
                                </>
                            }
                            <a href="details/" onClick={e => {e.preventDefault(); setShowProductDetails(!showProductDetails)}} className="link-energo">
                                {showProductDetails? 'Energieprodukt ausblenden':'Energieprodukt anzeigen'}
                            </a> <br />
                            {props.tickets && props.tickets.length > 0 &&
                                <>
                                    <a href="tickets/" onClick={e => {e.preventDefault(); setShowTickets(!showTickets)}} className="link-energo">
                                        {showTickets ? 'Support-Tickets ausblenden':'Support-Tickets anzeigen'}
                                    </a> <br />
                                </>
                            }
                        </Col>
                        <Col xs="12" md="4" xl="4" className="border-right" style={{paddingLeft: "30px"}}>
                            <h5 className="text-dark mb-3">
                                <BsFillDeviceSsdFill size="30" />&nbsp; Anlage {elv.x_anlage_id.x_studio_field_mWMGR}
                            </h5>
                            {elv.x_is_leerstand ? <TbZzz style={{ position: "relative", top: -65, right: -27 }} /> : null}
                            <b><i>{elv.x_anlage_id.x_adresse_kompakt}</i></b> <br />
                            <small className="text-muted me-1">Verwendung</small> 
                            {elv.x_anlage_id.x_anlagenverwendung_detail !== "" && elv.x_anlage_id.x_anlagenverwendung_detail !== "False" ?
                                    elv.x_anlage_id.x_anlagenverwendung_detail : elv.x_anlage_id.x_anlagenverwendung
                            } <br />
                            <small className="text-muted me-1">Energieform</small> {elv.x_anlage_id.x_studio_field_3eKe0} <br />
                            <small className="text-muted me-1">Zählernummer</small> {elv.x_anlage_id.x_zaehlernummer_01} <br />
                            {elv.x_anlage_id.x_zaehlernummer_02 !== "" && elv.x_anlage_id.x_zaehlernummer_02 !== "False" &&
                                <>
                                    <small className="text-muted me-1">Zählernummer 2</small>
                                    {elv.x_anlage_id.x_zaehlernummer_02}
                                    <br />
                                </>
                            }
                            <small className="text-muted me-1">Zählpunktnummer</small> {elv.x_anlage_id.x_zaehlpunktnummer_01} <br />
                            {elv.x_anlage_id.x_zaehlpunktnummer_02 !== "" && elv.x_anlage_id.x_zaehlpunktnummer_02 !== "False" &&
                                <>
                                    <small className="text-muted me-1">Zählpunktnummer 2</small> 
                                    {elv.x_anlage_id.x_zaehlpunktnummer_02}
                                    <br />
                                </>
                            }
                            {elv.x_verbrauch_alt_nb !== 'False' && elv.x_verbrauch_alt_nb !== '0' &&
                                <>
                                    <small className="text-muted me-1">Geschätzter Verbrauch</small> 
                                    {Number(elv.x_verbrauch_alt_nb).toLocaleString('DE-de')} KWh
                                    <br />
                                </>
                            }
                        </Col>
                        <Col xs="12" md="4" xl="4" style={{paddingLeft: "30px"}}>
                            <h5 className="text-dark mb-3"><BsFillBuildingsFill size={30}/>&nbsp; Rechnungsadresse</h5>
                            <small className="text-muted me-1">Straße</small> {elv.x_address_street} <br />
                            <small className="text-muted me-1">PLZ</small> {elv.x_address_plz} <br />
                            <small className="text-muted me-1">Ort</small> {elv.x_address_city} <br />
                        </Col>
                    </Row>
                    <Row id="productDetailsRow" hidden={!showProductDetails} className="my-3 border-top animate__animated animate__bounceInDown">
                        <p className="text-energo text-center mt-4 mb-4" style={{paddingLeft: "25px", marginTop: "10px"}}>
                            <MdEnergySavingsLeaf size={30} />&nbsp; Energieprodukt <br />
                            <small>{product.x_name}</small>
                        </p>
                        <Col xs="12" md="4" xl="4" style={{paddingLeft: "30px"}} className="border-right">
                            <small className="text-muted me-1">Vertragsart</small> {product.x_vertragsart} <br />
                            {product.x_vertragsart === 'Rahmenvertrag' &&
                                <>
                                    <small className="text-muted me-1">Vertragsdauer</small> 
                                    {UTILS.dateToEuFormat(product.x_vertragsdauer_von)} -&nbsp;
                                    {UTILS.dateToEuFormat(product.x_vertragsdauer_bis)}
                                    <br />
                                </>
                            }
                            <small className="text-muted me-1">Energielieferant</small> {product.x_energielieferant_id[1]} <br />
                        </Col>
                        <Col xs="12" md="4" xl="4" style={{paddingLeft: "30px"}} className="border-right">
                            {product.x_produkteigenschaft !== "False" &&
                                <>
                                    <small className="text-muted me-1">Produkteigenschaft</small> 
                                    {product.x_produkteigenschaft}
                                    <br />
                                </>
                            }
                            {product.x_vertragsbindung !== "0" &&
                                <>
                                    <small className="text-muted me-1">Vertragsbindung</small> 
                                    {product.x_vertragsbindung} Monate
                                    <br />
                                </>
                            }                            
                        </Col>
                        <Col xs="12" md="4" xl="4" style={{paddingLeft: "30px"}}>
                            {product.x_preis_kwh > 0 &&
                                <>
                                    <small className="text-muted me-1">Preis pro kWh exkl. USt</small> 
                                    {product.x_preis_kwh.toFixed(4)} ct
                                    <br />
                                    <small className="text-muted me-1">Grundgebühr/Monat exkl. USt</small> 
                                    {product.x_preis_grundgeb.toFixed(2)} €
                                    <br />
                                </>
                            }
                            {product.x_preis_kwh_rabattiert > 0 &&
                                <>
                                    <small className="text-muted me-1">Preis pro kWh inkl. Rabatt</small> 
                                    {product.x_preis_kwh_rabattiert.toFixed(4)} ct
                                    <br />
                                </>
                            }
                            {product.x_preisinfo !== "" && product.x_preisinfo !== "False" &&
                                <>
                                    {product.x_preisinfo}
                                    <br />
                                </>
                            }
                            {product.x_file_preisblatt_name !== "False" && product.x_file_preisblatt_name !== "" &&
                                <>
                                    <small className="text-muted me-1">Detaillierte Informationen zu Ihren Energieliefervertrag können Sie dem Preisblatt entnehmen</small>
                                    <br />
                                    <a onClick={e => download_base64(e)} href="download/" className="link-energo">Preisblatt ansehen</a>
                                    <br />
                                </>
                            }
                        </Col>
                    </Row>

                    <Row id="ticketDetailsRow" hidden={!showTickets} className="mt-3 border-top animate__animated animate__bounceInDown">
                        <p className="text-warning text-center mt-4 mb-4" style={{paddingLeft: "25px", marginTop: "10px"}}>
                            <BiSupport size={30} />&nbsp; Offene Tickets zu diesem Energieliefervertrag
                        </p>
                        {props.tickets && props.tickets.length > 0?
                            <Col xs="12" md="12" xl="12" style={{paddingLeft: "30px"}}>
                                <ListGroup variant="flush">
                                    {props.tickets.map(ticket => 
                                        <ListGroup.Item action onClick={() => navigate(`${user.x_is_house_management? '/hw':''}/dashboard/support/${ticket.id}`) }>
                                            <small className="text-muted">{new Date(ticket.create_date).toLocaleDateString('DE-de')}</small> &nbsp;
                                            <span className="text-warning">{ticket.name} (#{ticket.id})</span> &nbsp; 
                                            <Badge className="rounded-pill" bg={
                                                ticket.stage_id[1] === "Warten auf Drittpartei" ? "primary" :
                                                ticket.stage_id[1] === "On Hold" ? "warning" : 
                                                ticket.stage_id[1] === "Warten auf Kunde" ? "violet" : 
                                                ticket.stage_id[1] === "Warten auf ENERGO" ? "energo" : "secondary"
                                            }>
                                                {ticket.stage_id[1]}
                                            </Badge> &nbsp;
                                        </ListGroup.Item>
                                    )}
                                </ListGroup>
                            </Col>
                        :null}
                    </Row>
                </Card.Body>
                <Card.Footer style={{paddingTop: "20px", paddingBottom: "20px"}}>
                    <Row className="justify-content-center text-center">
                        <Col xs="12" md="4" xl="4" hidden={elv.x_anlage_id.x_studio_field_3eKe0 === "Strom-Einspeisung"}>
                            <a onClick={e => {e.preventDefault();  props.teilvorschreibungModal(true)}} href="/teilvorschreibung/anpassen/" className="link-energo"><TbCoins /> Teilvorschreibung anpassen</a>
                        </Col>
                        {/* <Col xs="12" md="3" xl="3" hidden={true}>
                            <a onClick={e => {e.preventDefault(); props.leerstandModal(true)}} href="/leerstand/abmelden/" className="link-energo"><TbZzzOff /> Leerstand abmelden</a>
                        </Col> */}
                        <Col xs="12" md="4" xl="4">
                            <a onClick={e => {e.preventDefault(); supportHandler()}} href="/support/" className="link-energo"><FaQuestion /> Frage zu diesem Vertrag</a>
                        </Col>
                        <Col xs="12" md="4" xl="4">
                            <a onClick={e => {e.preventDefault(); props.setMissingInvoiceModal(true)}} href="/rechnung/fehlt/" className="link-energo"><FaFileInvoiceDollar /> Fehlende Abrechnung</a>
                        </Col>
                    </Row>
                </Card.Footer>
            </Card>   
        
        </>
    )
}

export default ElvDetailsCard;